import "vue-toastification/dist/index.css";

import { App } from "vue";
import Toast from "vue-toastification";
import CommonToast from "@/components/Common/CToast.vue";
import Maska from "maska";
import apiService from "@/services/ApiService";
import { createPinia } from "pinia";
import ru from "dayjs/locale/ru";
import uz from "dayjs/locale/uz-latn";
import en from "dayjs/locale/en";
import relativeTime from "dayjs/plugin/relativeTime.js";
import LocalizedFormat from "dayjs/plugin/localizedFormat";
import dayjs from "dayjs";
import * as Sentry from "@sentry/vue";
import router from "@/router";

export default function definePlugins(app: App): App {
  apiService.init(app);
  //Toast Notification
  const pinia = createPinia();
  const options = {
    position: "top-right",
    timeout: 3000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: true,
    hideProgressBar: true,
    closeButton: true,
    icon: true,
    rtl: false,
    maxToasts: 3,
    newestOnTop: true,
    component: CommonToast,
  };
  dayjs.extend(relativeTime);
  dayjs.extend(LocalizedFormat);
  dayjs.locale(ru);
  dayjs.locale(uz);
  dayjs.locale(en);
  if (import.meta.env.VITE_APP_MODE === "production") {
    Sentry.init({
      app,
      dsn: "https://6c7424c02b522c5ed8720d1c5d699aeb@o4508664349261824.ingest.de.sentry.io/4508664354177104",
      integrations: [
        Sentry.browserTracingIntegration({ router }),
        Sentry.replayIntegration(),
      ],
      allowUrls: [/https?:\/\/((cdn|www)\.)?app.sarafrobot\.com/],
      // Tracing
      tracesSampleRate: 0.5, //  Capture 100% of the transactions
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
      failedRequestStatusCodes: [400, 599],
    });
    app.config.errorHandler = (err, instance, info) => {
      console.error("Global error:", err, info);
      // Send error details to a monitoring service like Sentry
      // Send the error to Sentry
      Sentry.captureException(err, {
        contexts: {
          vue: {
            info,
            component: instance?.$options?.name || "Anonymous Component",
            props: instance?.$props,
          },
        },
      });
    };
  }

  app.use(dayjs);
  app.use(pinia);
  app.use(Maska);
  app.use(Toast, options);
  return app;
}
